import { howItWorksSteps } from '@/mocks/categories';

export default function HowItWorks() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1000px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-3">
            How Kakobuy Spreadsheet Works
          </h2>
          <p className="text-sm text-foreground-600 max-w-[560px] mx-auto">
            Getting started with product discovery is simple. Here is how it works in three easy steps.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {howItWorksSteps.map((step) => (
            <div key={step.step} className="relative text-center group">
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mx-auto mb-4 group-hover:bg-accent-200 transition-colors">
                <i className={`${step.icon} text-2xl`}></i>
              </div>
              <div className="inline-flex items-center justify-center w-7 h-7 rounded-full bg-primary-500 text-background-50 text-xs font-bold mb-3">
                {step.step}
              </div>
              <h3 className="font-semibold text-foreground-900 text-sm mb-2">{step.title}</h3>
              <p className="text-xs text-foreground-600 leading-relaxed max-w-[260px] mx-auto">{step.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold rounded-lg bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            Start Discovering Products
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}